<template>
    <h3 class="tag filter">{{tag | parseTag}}</h3>
</template>

<script>

export default {
  props: ['tag']
}

</script>

<style lang="scss" scoped>
.filter {
    @extend %linkify;
    transition: color .5s ease-out;
    color: $gray5 !important;

    &:hover {
        color: $gray2 !important;
    }

}

.active {
    color: $gray2 !important;
}
</style>
